<template>
    <div class="w-full h-auto relative flex justify-center">
        <img src="../../assets/img/Desktop/Home/1.webp" alt="" class="w-full h-auto">
        <div class="absolute bottom-0 w-full h-[25vw] bg-gradient-to-t from-[#171717] to-transparent"></div>
        <img src="../../assets/img/Desktop/Home/2.webp" alt="" class="absolute flex items-center top-[3vw] w-[60vw]">
        <div class="absolute top-[22.5vw] bg-white w-[37.5vw] h-[19.5vw] rounded-full radial-layer-shadow"></div>
        <div class="flex flex-col justify-center absolute top-[22.5vw] items-center">
            <img src="../../assets/img/Desktop/Home/IdleGlory.png" alt="" class="w-[25vw]">
            <p class="font-league text-white text-[1.67vw] font-medium">Awaken the Lengend within you!</p>
            <p class="font-league text-white text-[0.83vw] font-semibold">The ultimate turn-based tactical Idle RPG: Where strategy and perseverance transform you into a legend.</p>
            <img src="../../assets/img/Desktop/Home/EnterAerthospng.webp" alt="" class="w-[7.4vw] mt-[0.4vw] hover:cursor-pointer hover:opacity-80 duration-500 transition-all ease-in-out" @click="openWebLink('https://play.idle-glory.io/')">
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}

.radial-layer-shadow {
  background: radial-gradient(circle, #171717 0%, transparent 100%);
  filter: blur(1vw);
}
</style>